import { render, staticRenderFns } from "./SISAttendanceWidget.vue?vue&type=template&id=76991fc2&"
import script from "./SISAttendanceWidget.vue?vue&type=script&lang=js&"
export * from "./SISAttendanceWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../CommunityWebPortal/_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76991fc2')) {
      api.createRecord('76991fc2', component.options)
    } else {
      api.reload('76991fc2', component.options)
    }
    module.hot.accept("./SISAttendanceWidget.vue?vue&type=template&id=76991fc2&", function () {
      api.rerender('76991fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueCommon/common-components/src/components/Widgets/SISAttendanceWidget.vue"
export default component.exports